export default (form) => {
  const confirmationElement = form.previousElementSibling;
  if (confirmationElement && confirmationElement.matches('[data-form-confirmation]')) {
    confirmationElement.classList.remove('Confirmation--hidden');
  }
  form.style.display = 'none';
};
